const key = 'rdc_x_map_seen_properties';
const max = 5000;

export function getFromlocalStorage(key) {
  try {
    return JSON.parse(localStorage.getItem(key));
  } catch (err) {
    return null;
  }
}

export function setAtlocalStorage(key, value) {
  try {
    localStorage.setItem(key, value);
  } catch (err) {
    /** intentionally blank, for now */
  }
}

export const getSeenProperties = () => {
  if (!window) return [];

  return getFromlocalStorage(key) || [];
};

export const markAsSeen = (property_id) => {
  if (!window) return;

  const items = getSeenProperties();

  property_id = `${property_id}`;
  const index = items.indexOf(property_id);
  if (index > -1) {
    items.splice(index, 1);
  }
  items.unshift(property_id);
  if (items.length > max) {
    items.pop();
  }
  setAtlocalStorage(key, JSON.stringify(items));
};



// WEBPACK FOOTER //
// ./shared_critical/propertySeen.js